import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { Icon } from "react-icons-kit";
import { facebook } from "react-icons-kit/fa/facebook";
import { dribbble } from "react-icons-kit/fa/dribbble";
import { googlePlus } from "react-icons-kit/fa/googlePlus";
import { skype } from "react-icons-kit/fa/skype";
import { twitter } from "react-icons-kit/fa/twitter";
import Box from "common/components/Box";
import Text from "common/components/Text";
import Heading from "common/components/Heading";
import Logo from "common/components/UIElements/Logo";
import Container from "common/components/UI/Container";
import Button from "common/components/Button";
import FooterWrapper, {
  CurvIcon,
  List,
  ListItem,
  SocialList,
} from "./footer.style";

const socialLinks = [
  {
    id: 1,
    icon: <Icon icon={facebook} />,
    name: "facebook",
    link: "#",
  },
  {
    id: 2,
    icon: <Icon icon={dribbble} />,
    name: "dribbble",
    link: "#",
  },
  {
    id: 3,
    icon: <Icon icon={googlePlus} />,
    name: "googlePlus",
    link: "#",
  },
  {
    id: 4,
    icon: <Icon icon={skype} />,
    name: "skype",
    link: "#",
  },
];

const Footer = ({ row, col, colOne, colTwo }) => {
  const data = useStaticQuery(graphql`
    query {
      interiorJson {
        footerData {
          logo {
            publicURL
          }
          mail
          phone
          menuWidgets {
            id
            title
            menu {
              id
              text
              link
            }
          }
        }
      }
    }
  `);
  const { logo, mail, phone, menuWidgets } = data.interiorJson.footerData;

  return (
    <Fragment>
      <FooterWrapper>
        <Container width="1330px">
          <Box className="row" {...row}>
            <Box className="col-one" {...colOne}>
              <Logo
                className="logo"
                href="/interior"
                logoSrc={logo.publicURL}
                title="Interior"
              />
              <a href="mailto:info@direct4.me">
                {" "}
                <Text className="text" content={mail} />
              </a>
              <a href="tel:+38651305500">
                {" "}
                <Text className="text" content={phone} />
              </a>
              <b>
                {" "}
                <a href="/newsroom" style={{ color: "#00A5C0" }}>
                  Newsroom
                </a>
              </b>
              {/*<SocialList>
                {socialLinks.map((item) => (
                  <li className={item.name} key={`link-key${item.id}`}>
                    <a aria-label={item.name} href={item.link}>
                      {item.icon}
                    </a>
                  </li>
                ))}
                </SocialList> */}
            </Box>
            {/* End of logo column */}

            <Box className="col-two" {...colTwo}>
              <Heading as="h2" content="Get in touch" />
              <Text
                className="text2"
                content="Upgrade your infrastructure and give your customers the best possible experience."
              />
              <a href="mailto:info@direct4.me">
                <Button
                  type="submit"
                  className="mainbutton"
                  colors="primaryWithBg"
                  title="CONTACT US"
                />
              </a>
            </Box>
            {/* End of List column */}
          </Box>
          {/* End of widgets row */}
          <Box className="row copyright" {...row}>
            <Text className="text" content="© Copyright Direct4.me" />
            <p>
              <a href="terms">Terms and conditions</a>&nbsp;&nbsp;
              <a href="shippingpolicy">Shipping policy</a>&nbsp;&nbsp;
              <a href="legalnotice">Legal notice</a>&nbsp;&nbsp;
              <a href="https://www.direct4.me/sl-si/">Slovenščina</a>
            </p>
          </Box>
          {/* End of copyright row */}
        </Container>
      </FooterWrapper>
    </Fragment>
  );
};

// Footer style props
Footer.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  colOne: PropTypes.object,
  colTwo: PropTypes.object,
};

// Footer default style
Footer.defaultProps = {
  // Footer row default style
  row: {
    flexBox: true,
    flexWrap: "wrap",
    ml: "-15px",
    mr: "-15px",
  },
  // Footer col one style
  colOne: {
    width: ["100%", "30%", "35%", "28%"],
    mt: [0, "13px", "0"],
    mb: ["30px", 0],
    pl: ["15px", 0],
    pr: ["15px", "15px", 0],
  },
  // Footer col two style
  colTwo: {
    width: ["100%", "70%", "65%", "72%"],
    flexBox: true,
    flexWrap: "wrap",
  },
  // Footer col default style
  col: {
    width: ["100%", "50%", "50%", "25%"],
    pl: "15px",
    pr: "15px",
    mb: "30px",
  },
};

export default Footer;
